module.exports = __webpack_public_path__ + "img/5bd206d.jpg";